import React, { useRef, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';
import HomeEventList from '../components/HomeEventList';
import Loader from '../components/Loader';
import CookieConsentComponent from '../components/CookieConsentComponent';
import { fetchEvents, fetchPartners } from '../api/api';
import Partners from '../components/Partners';
import SEO from '../components/SEO';
import InfosPratiques from '../components/InfosPratiques';
import EventListAlpha from '../components/EventListAlpha';
import FAQ from '../components/FAQ';

const HomePage = () => {
  const containerRef = useRef(null);
  const location = useLocation();

  const {
    data: eventsData = { data: [], pagination: null },
    isLoading: loadingEvents,
  } = useQuery({
    queryKey: ['events'],
    queryFn: () => fetchEvents({ page: 1, limit: 20 }),
    staleTime: 5 * 60 * 1000,
    retry: 2,
  });

  const {
    isLoading: loadingPartners,
  } = useQuery({
    queryKey: ['partners'],
    queryFn: fetchPartners,
    staleTime: 5 * 60 * 1000,
    retry: 2,
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  if (loadingEvents || loadingPartners) {
    return <Loader />;
  }

  return (
    <div className="app-container" ref={containerRef}>
      <SEO
        title=""
        description="Festival électro incontournable de l'été toulousain : 3 mois de fête, stars internationales et ambiance unique sur le tarmac de l'aéroport du 11 juin au 31 août 2025."
        url="/"
      />
      <EventListAlpha />
      <HomeEventList
        events={eventsData}
        currentEventId={null}
        isEventPage={false}
        className="horizontal-scroll"
      />
      <InfosPratiques />
      <FAQ />
      <div className="partners-section">
        <Partners />
      </div>
    </div>
  );
};

export default HomePage;
